<template lang="pug">
  .pagination
    template(v-for="page of pages")
      template(v-if="current !== page")
        .pagination__item(@click="load(page)") {{ page }}
      template(v-else-if="page === current")
        .pagination__item.pagination__item_active {{ page }}
</template>

<script>
export default {
  name: 'Pagination',
  components: {},
  props: {
    pages: {
      type: Number,
      required: false,
      default: 1,
    },
    current: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  data: () => ({}),
  methods: {
    load(page) {
      this.$router.replace({ query: { page } });
      this.$emit('load', page);
    },
  },
};
</script>
